module.exports = __webpack_public_path__ + "img/standard-lead-item-1.fe865dfb.png";